import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { usePrivileges } from '../contexts/PrivilegesContext.js';
import { useUserModel } from '../contexts/UserContext.js';
/**
 * This hook provides the user model with its privileges and access.
 * @returns {UserModel}
 */ export var useUser = function useUser() {
    var user = useUserModel();
    var _usePrivileges = usePrivileges(), privileges = _usePrivileges.privileges, access = _usePrivileges.access;
    return _object_spread_props(_object_spread({}, user), {
        privileges: privileges,
        access: access
    });
};

//# sourceMappingURL=useUser.js.map